import React, { useState, createContext } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/SideBar';

export const AppContext = createContext();

const MainLayout = () => {
  const [selectedLocation, setSelectedLocation] = useState();
  const [filters, setFilters] = useState({});
  const [liveData, setLiveData] = useState(null);
  const [templateData, setTemplateData] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const contextValue = {
    selectedLocation,
    setSelectedLocation,
    filters,
    setFilters,
    liveData,
    setLiveData,
    templateData,
    setTemplateData,
  };

  return (
    <AppContext.Provider value={contextValue}>
      <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
        <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Header
            selectedLocation={selectedLocation}
            onSelectLocation={setSelectedLocation}
            onToggleSidebar={() => setIsSidebarOpen(prev => !prev)}
          />
          <main style={{ padding: '16px', overflowY: 'auto', flex: 1 }}>
            <Outlet />
          </main>
        </div>
      </div>
    </AppContext.Provider>
  );
};

export default MainLayout;
